<script setup lang="ts">
import { GpBrandLoading } from '@gportal/uikit';
</script>

<template>
  <GpBrandLoading animate class="tw-mx-auto tw-mt-4">
    <p class="tw-font-bold tw-uppercase">
      <slot></slot>
    </p>
  </GpBrandLoading>
</template>

<style scoped></style>
